<div class="brand-widget-container tcm-details-panel mb-4" *ngIf="viewModel">
  <div class="info-container">
    <div class="section logo">
      <div class="photo-wrapper">
        <img class="brand-logo" src="{{viewModel.logo || '/assets/images/no-photo.jpg'}}" />
        <div class="upload-logo" *ngIf="canUpdatePhoto">
          <a href="#" oncontextmenu="return false;" (click)="openUplaodLogoModal($event)">
            {{'Screens.Brands.InfoWidget.Update' | translate}}
          </a>
        </div>
      </div>
    </div>
    <div class="section info"></div>
    <div class="section brand-info">
      <span class="section-header">{{ viewModel.name }}</span>
      <hr />
      <div class="description">
        <div *ngIf="viewModel.code">
          {{'Common.SearchColumnsAndDetailsFields.Code' | translate}}: {{ viewModel.code }}
        </div>
      </div>
    </div>
  </div>
</div>
